import { NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ModalService } from 'src/app/core/services/modal.service';
import { ArrayListModalComponent } from '../../modals/array-list-modal/array-list-modal.component';
import { AnalyticsService } from 'src/app/core/services/analytics.service';

@Component({
  selector: 'pa-table-array-cell',
  standalone: true,
  imports: [NgFor, NgIf],
  templateUrl: './pa-table-array-cell.component.html',
  styleUrls: ['./pa-table-array-cell.component.scss'],
})
export class PaTableArrayCellComponent {
  @Input() value: unknown;
  @Input() maxVisible?: number;
  @Input() modalTitle: string;

  constructor(private readonly modalService: ModalService, private readonly analyticsService: AnalyticsService) {}

  get values(): unknown[] {
    if (Array.isArray(this.value)) {
      return this.value;
    }
    if (this.value === null || this.value === undefined) {
      return [];
    }
    return [this.value];
  }

  get visibleItems(): unknown[] {
    if (!this.values.length) {
      return [];
    }

    const limit = this.maxVisible && this.maxVisible > 0 ? this.maxVisible : this.values.length;
    return this.values.slice(0, limit);
  }

  get remainingCount(): number {
    const limit = this.maxVisible && this.maxVisible > 0 ? this.maxVisible : this.values.length;
    return Math.max(0, this.values.length - limit);
  }

  formatItem(item: unknown): string {
    if (item === null || item === undefined) {
      return '';
    }

    if (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean') {
      return String(item);
    }

    if (typeof item === 'object' && 'name' in (item as Record<string, unknown>)) {
      const value = (item as { name?: unknown }).name;
      return value !== undefined && value !== null ? String(value) : '';
    }

    return '';
  }

  onMoreClick(event: Event): void {
    event.stopPropagation();
    if (!this.values.length) {
      return;
    }

    this.analyticsService.phCapture(`Кнопка ${this.modalTitle} нажата`);

    this.modalService.prepareWrapperConfigForNextModal({
      title: this.modalTitle || 'Список',
    });

    this.modalService
      .createWithDynamicComponent({
        component: ArrayListModalComponent,
        componentProps: { items: this.values },
        viewConfig: {
          isRightSideModal: true,
          useAnimation: true,
        },
      })
      .subscribe();
  }
}

